"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
/**
 * debounce decorator
 *
 * @debounce(delay: number, immediate: boolean = true)
 * action()  {
 *    // do some real work
 * }
 */
// tslint:disable:no-invalid-this
function debounce(delay, immediate) {
    if (immediate === void 0) { immediate = true; }
    return function (target, methodKey, descriptor) {
        var innerMethod = descriptor.value;
        descriptor.value = _.debounce(function () {
            return innerMethod.apply(this, arguments);
        }, delay, immediate);
        return descriptor;
    };
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map